import React, { useMemo } from "react"
import { motion } from "framer-motion"
import styled from "styled-components"

const StyledSvg = styled(motion.svg)`
	position: absolute;
	z-index: 2;
	bottom: 1px;
	left: 0;
	transform: translate(-100%, 100%);
	width: 100%;
	height: 310px;
	fill: white;
	stroke: none;

	path {
		opacity: 0;
	}
`

export default function Curve({ variant = "open", svgPaths, id = "" }) {
	const [svgPath, width] = useMemo(() => {
		if (!svgPaths) return

		return [svgPaths[variant].initialPath, svgPaths.width]
	}, [variant, svgPaths])
	// const svgPath = useMemo(() => PATHS[variant].initialPath, [svgPaths])

	return (
		<StyledSvg className={`${id}-curved-svg-wrapper`} viewBox={`0 0 ${width} 310`} preserveAspectRatio="xMidYMid meet">
			<path className={`${id}-curved-${variant}`} d={svgPath}></path>
		</StyledSvg>
	)
}
